module.exports = __webpack_public_path__ + "60667160bc72749e74ff0d3bbc8ecbcf.obj";